import axios from 'axios'

const getApiBaseUrl = () => (axios.defaults.baseURL || '').replace(/\/+$/, '')

const LandingService = {
  // Announcements
  async getAnnouncements (params = {}) {
    return axios.get('landing/announcements', { params })
  },

  async getAnnouncement (id) {
    return axios.get(`landing/announcements/${id}`)
  },

  // Events
  async getEvents (params = {}) {
    return axios.get('landing/events', { params })
  },

  async getEvent (id) {
    return axios.get(`landing/events/${id}`)
  },

  // Lost & Found
  async submitLostItem (data) {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== '') {
        formData.append(key, data[key])
      }
    })
    return axios.post('landing/lost-items', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  async searchFoundItems (params = {}) {
    return axios.get('landing/found-items', { params })
  },

  // Appointments
  async submitAppointment (data) {
    return axios.post('landing/appointments', data)
  },

  async sendAppointmentOtp (email) {
    return axios.post('landing/appointments/send-otp', { email })
  },

  async verifyAppointmentOtp (email, otp) {
    return axios.post('landing/appointments/verify-otp', { email, otp })
  },

  // Available appointment slots (public)
  async getAvailableSlots (params = {}) {
    return axios.get('landing/appointments/available-slots', { params })
  },

  // Concern types (public)
  async getConcernTypes (params = {}) {
    return axios.get('landing/appointments/concern-types', { params })
  },

  // Check appointment by reference number
  async checkAppointment (referenceNumber) {
    return axios.get(`landing/appointments/${encodeURIComponent(referenceNumber)}`)
  },

  async updateAppointment (referenceNumber, data) {
    return axios.put(`landing/appointments/${encodeURIComponent(referenceNumber)}`, data)
  },

  async cancelAppointment (referenceNumber) {
    return axios.patch(`landing/appointments/${encodeURIComponent(referenceNumber)}/cancel`)
  },

  // Resources
  async getResources (params = {}) {
    return axios.get('landing/resources', { params })
  },

  getResourceViewUrl (slug) {
    return `${getApiBaseUrl()}/landing/resources/view/${encodeURIComponent(slug)}`
  },

  getResourceDownloadUrl (slug) {
    return `${getApiBaseUrl()}/landing/resources/download/${encodeURIComponent(slug)}`
  },

  // Feedback (public / non-student)
  async submitFeedback (data) {
    return axios.post('landing/feedback', data)
  }
}

export default LandingService
